// extracted by mini-css-extract-plugin
module.exports = {"root":"layout-module--root--1So81","header":"layout-module--header--379cn","main":"layout-module--main--2yme8","gutter":"layout-module--gutter--1qBQK"};